import { List } from '@mui/material';
import NavItem from 'src/layouts/DashboardLayout/NavBar/NavItem';
import { matchPath } from 'react-router-dom';

export function renderNavItems({ items, pathname, expanded, depth = 0, statuses }) {
  return (
    <List disablePadding>
      {items.reduce((acc, item) => reduceChildRoutes({ acc, item, pathname, depth, expanded, statuses }), [])}
    </List>
  );
}

const mergeStatuses = (statusList) => {
  const list = (statusList || []).filter(Boolean);
  if (list.length === 0) {
    return undefined;
  }

  const hasError = list.some((status) => status.type === 'error' || status.type === 'full');
  const hasWarning = list.some((status) => status.type === 'warning' || status.type === 'partial');
  const tooltipParts = list.map((status) => status.tooltip).filter(Boolean);
  const tooltip = tooltipParts.length > 1 ? tooltipParts.join(' • ') : tooltipParts[0] || '';

  return {
    type: hasError ? 'error' : hasWarning ? 'warning' : list[0].type,
    blocked: list.some((status) => status.blocked),
    tooltip,
  };
};

export function reduceChildRoutes({ acc, pathname, item, depth, expanded, statuses }) {
  const key = item.title + depth;
  const route = item.route;
  const isContentRoute = route?.splitTarget === 'content';
  const statusFromKeys = item.statusKeys ? mergeStatuses(item.statusKeys.map((statusKey) => statuses?.[statusKey])) : undefined;
  const status = item.status || statusFromKeys || (item.statusKey ? statuses?.[item.statusKey] : undefined);
  const disabledState =
    item.disabledState ||
    (item.disabledStatusKeys ? mergeStatuses(item.disabledStatusKeys.map((k) => statuses?.[k])) : undefined) ||
    (item.disabledStatusKey ? statuses?.[item.disabledStatusKey] : undefined);

  if (item.items) {
    let open = null;

    if (route?.path && !isContentRoute) {
      open = matchPath(
        {
          path: route.path,
          end: false,
        },
        pathname,
      );
    }

    acc.push(
      <NavItem
        depth={depth}
        icon={item.icon}
        info={item.info}
        key={key}
        open={Boolean(open)}
        title={item.title}
        expanded={expanded}
        route={route}
        status={status}
        disabledState={disabledState}
      >
        {renderNavItems({
          depth: depth + 1,
          pathname,
          items: item.items,
          statuses,
        })}
      </NavItem>,
    );
  } else if (route?.accessible) {
    acc.push(
      <NavItem
        depth={depth}
        icon={item.icon}
        info={item.info}
        key={key}
        title={item.title}
        expanded={expanded}
        route={route}
        status={status}
        disabledState={disabledState}
        suppressActive={item.suppressActive}
      />,
    );
  }

  return acc;
}
